import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneLapResult, deleteLapResult } from "./../../../store/actions";
import { useLocation, useParams } from "react-router-dom";
import View from "../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewLapResult = ({
  getOneLapResult,
  lapResult,
  deleteLapResult,
  history,
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [oneLapResult, setLapResult] = useState(null);
  let params = useParams();
  const location = useLocation();
  const sharedToken = new URLSearchParams(location.search).get("sharedToken");
  const toast = useToast();
  const removeLapResult = () => {
    deleteLapResult(params.id, toast, history, "/medical-record/lab-result");
  };
  useEffect(() => {
    if (params && params.id && params.patientId && sharedToken) {
      getOneLapResult(params.id, toast, history, params.patientId, sharedToken);
    } else if (params && params.id && !params.patientId && !sharedToken) {
      getOneLapResult(params.id, toast, history);
    }
  }, [params.id, toast, history, sharedToken, getOneLapResult]);
  useEffect(() => {
    const { loading, error, data } = lapResult;
    setLoading(loading);
    setError(error);
    if (data) {
      setLapResult(data);
    }
  }, [lapResult]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View Lab Result"
        linkEdite="/medical-record/lab-result/add-Lab-result"
        one={oneLapResult}
        params={params}
        removeOne={removeLapResult}
        backLink={
          sharedToken
            ? `/lab-result/${params.patientId}/shared-data?sharedToken=${sharedToken}`
            : "/medical-record/lab-result"
        }
        nameForAlert="Lab Result"
      />
    );
  };
  return renderView();
};
const mapStateToProps = (state) => {
  return {
    lapResult: state.oneLapResult,
  };
};
export default connect(mapStateToProps, { getOneLapResult, deleteLapResult })(
  ViewLapResult
);
